import { render, staticRenderFns } from "./EsgDisclosureTemplateNew.vue?vue&type=template&id=01c43f4a&scoped=true"
import script from "./EsgDisclosureTemplateNew.vue?vue&type=script&lang=js"
export * from "./EsgDisclosureTemplateNew.vue?vue&type=script&lang=js"
import style0 from "./EsgDisclosureTemplateNew.vue?vue&type=style&index=0&id=01c43f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c43f4a",
  null
  
)

export default component.exports